import { useMutation } from '@tanstack/react-query';
import { reviewJoinRequest } from '../../services/joinRequests';
import { ReviewJoinRequestPayload } from '../../types/joinRequests';

interface Options {
  onSuccess?: () => void;
  onError?: () => void;
}

function useReviewJoinRequest({ onSuccess, onError }: Options = {}) {
  return useMutation({
    mutationFn: ({
      requestId,
      payload,
    }: {
      requestId: string;
      payload: ReviewJoinRequestPayload;
    }) => reviewJoinRequest(requestId, payload),
    onSuccess,
    onError,
  });
}

export default useReviewJoinRequest;
